import React from 'react'
import { v4 as uuidv4 } from 'uuid'

import BEMHelper from '@ynap/bem-helper'

import type { ProgressBarProps } from './types'

const bem = new BEMHelper('ProgressBar')

/*
Progress value should be a number between 0 and 1 and represents
the progress within an interval
*/
function ProgressBar(props: ProgressBarProps) {
    const { className, title, intervalMinLabel, intervalMaxLabel, value = 0, colorScheme = 'dark' } = props

    const progressBarId = `progressBar-${uuidv4()}`

    return (
        <div className={bem(null, colorScheme, className)}>
            <label htmlFor={progressBarId} className={bem('title')}>
                {title}
            </label>
            {intervalMinLabel && intervalMaxLabel ? (
                <p className={bem('intervalLabels')}>
                    <span>{intervalMinLabel}</span>
                    <span>{intervalMaxLabel}</span>
                </p>
            ) : null}
            <progress id={progressBarId} className={bem('progressBar', colorScheme)} value={value} max={1} />
        </div>
    )
}

export default ProgressBar
